import ProjectSession from "../../../core/model2/project/project-session"
import {EVENT_BUS_MENU_RERENDER} from "../sections/const"
import NavigationMenu_ProjectsLocalSettings from "../local-settings"
import {SpaceProto} from "../../../core/model2/space/space-proto"

export default function menu_expandAllProjects(space: SpaceProto, localSettings?: NavigationMenu_ProjectsLocalSettings) {
    const expandedProjects: ID[] = []

    const recursiveExpand = (project:ProjectSession) => {
        if (project.isSection) return // skip sections and all its children

        expandedProjects.push(project.id)

        _.map(project.treeChildren, (childProject: ProjectSession) => {
            recursiveExpand(childProject)
        })
    }

    _.map(space.rootProjects, (project: ProjectSession) => {
        recursiveExpand(project)
    })

    if (localSettings) {
        localSettings.expandedProjects = _.union(localSettings.expandedProjects, expandedProjects)
        localSettings.save()
    }

    gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
}